import React from "react";
import { useIntl } from "react-intl";
import Button from "../../components/button/Button";

import { ReactComponent as BackSVG } from "../../assets/arrow-left.svg";

import {
  EconomyPage,
  FusePage,
  ImportantNotePage,
  OverviewPage,
  PerfectPage,
} from "./InfoScreenPages";

import { useNavigate, useOutletContext } from "react-router-dom";
import LeftMenuBurger from "../../components/LeftMenuBurger";
import { useThemeStyles } from "../../store/ui/ThemeProvider";
import { useUIState } from "../../store/ui/UIState";
import { PageLayoutOutletContext } from "../../template/PageLayout";
import "./info_screen.scss";

const componentByPage = [
  OverviewPage,
  FusePage,
  EconomyPage,
  PerfectPage,
  ImportantNotePage,
];

function InfoScreen() {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { instructionsStyles } = useThemeStyles();
  const { toggleLeftMenu } = useUIState();
  const outlet = useOutletContext<PageLayoutOutletContext>();

  const [currentPage, changeCurrentPage] = React.useState(0);

  const backClick = React.useCallback(() => {
    if (currentPage > 0) {
      return changeCurrentPage((p) => p - 1);
    } else {
      return navigate(outlet.generatePath("/"));
    }
  }, [currentPage, navigate, outlet]);

  const nextClick = React.useCallback(() => {
    if (currentPage + 1 === componentByPage.length) {
      return navigate(outlet.generatePath("/"));
    }

    changeCurrentPage((p) => p + 1);
  }, [currentPage, navigate, outlet]);

  const Component = componentByPage[currentPage];

  return (
    <div className="info_screen" style={instructionsStyles}>
      <div className="page-header">
        <LeftMenuBurger onClick={toggleLeftMenu} />
        <div className="pages-thumb">
          {Array.from({ length: componentByPage.length }).map((_, i) => (
            <React.Fragment key={i}>
              {i > 0 && <div className="thumb-separator" />}
              <div
                className={[
                  "thumb-item",
                  currentPage === i ? "active" : undefined,
                ]
                  .filter((e) => e)
                  .join(" ")}
              />
            </React.Fragment>
          ))}
        </div>
        <div />
      </div>
      <div className="page-content">
        <Component />
      </div>
      <div className="page-controls">
        {typeof backClick == "function" && (
          <Button
            buttonType="dark"
            Icon={BackSVG}
            title={formatMessage({ id: "button.back" })}
            onClick={backClick}
          />
        )}

        <div style={{ flex: "auto" }} />
        <Button
          title={formatMessage({ id: "button.next" })}
          buttonType="success"
          onClick={nextClick}
        />
      </div>
    </div>
  );
}

export default InfoScreen;
